import { useState, useEffect, useCallback } from "react";
import { getSalesList } from "../../api/sales";
import dayjs from 'dayjs';

const useSalesList = (storeId, startDate, endDate, isReceive, page = 1, size = 10) => {
  const [salesList, setSalesList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      if (storeId) {
        const response = await getSalesList(
          storeId,
          startDate ? dayjs(startDate).format("YYYY-MM-DD") : undefined,
          endDate ? dayjs(endDate).format("YYYY-MM-DD") : undefined,
          isReceive,
          page,
          size
        );
        setSalesList(response.data);
        setTotalCount(response.totalCount);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }, [storeId, startDate, endDate, isReceive, page, size]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { salesList, totalCount, loading, error, refresh: fetchData };
};

export default useSalesList;
